import * as React from "react";
import { ProductDetailFeatures } from "./ProductDetailFeatures.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const ProductDetailFeaturesContainer = () => {
  const { activeVariant } = useProductData();
  if ("productFeatures" in activeVariant && !!activeVariant.productFeatures.length) {
    return /* @__PURE__ */ React.createElement(ProductDetailFeatures, { productFeatures: activeVariant.productFeatures });
  }
  return null;
};
export {
  ProductDetailFeaturesContainer
};
//# sourceMappingURL=ProductDetailFeaturesContainer.js.map
